// Copyright 2022-2024, 2026 - Hewlett Packard Enterprise Company
import { useState, useContext } from 'react';
import { Anchor, Box, Button } from 'grommet';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { getServerSetting } from '../../actions/Api';
import ServerSettingDeletedModal from '../ServerSettingDeletedModal/ServerSettingDeletedModal';
import TextEmphasis from '../TextEmphasis/TextEmphasis';
import { AuthContext } from '../../contexts/AuthContext';

export default function ServerSettingsDetailsLink({
  id,
  name,
  tenantAcid,
  handleError,
  useButton,
}) {
  const [disabledOpen, setDisabledOpen] = useState(false);
  const [disabledServerSettings, setDisabledServerSettings] = useState();
  const history = useHistory();
  const { updateTenantAcid } = useContext(AuthContext);
  const serverSettingUrlPrefix = '/settingDetail/';

  const openDisabledModal = device => {
    setDisabledServerSettings(device);
    setDisabledOpen(true);
  };

  const updateTenantAndRedirect = (tenantAcid, route, data) => {
    tenantAcid && updateTenantAcid(tenantAcid);
    history.push(route, data);
  };

  const onClickServerSettingsLink = async (
    serverSettingsId,
    serverSettingsName,
    handleErr,
  ) => {
    let serverSetting = null;
    if (serverSettingsId) {
      const resp = await getServerSetting(serverSettingsId, tenantAcid).catch(
        error => {
          if (error?.response?.status === 404)
            openDisabledModal(serverSettingsName);
          else handleErr(error);
        },
      );
      if (resp) {
        serverSetting = resp.data;
      }
    }

    if (serverSetting) {
      updateTenantAndRedirect(
        tenantAcid,
        `${serverSettingUrlPrefix}${serverSettingsId}`,
        serverSetting,
      );
    }
  };

  return (
    <Box>
      {useButton ? (
        <Button
          onClick={() => {
            onClickServerSettingsLink(id, name, handleError);
          }}
        >
          <Box>
            <TextEmphasis truncate="tip">{name}</TextEmphasis>
          </Box>
        </Button>
      ) : (
        <Anchor
          label={name}
          onClick={() => {
            onClickServerSettingsLink(id, name, handleError);
          }}
        />
      )}
      {disabledOpen && (
        <ServerSettingDeletedModal
          data={disabledServerSettings}
          onClose={() => {
            setDisabledOpen(false);
          }}
        />
      )}
    </Box>
  );
}

ServerSettingsDetailsLink.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  tenantAcid: PropTypes.string,
  handleError: PropTypes.func.isRequired,
  useButton: PropTypes.bool,
};
